import { Stack, styled } from "@mui/material";

export const FeedbacksContainer = styled(Stack)`
  text-align: initial;
`;
